import { NgModule } from '@angular/core';

import { ConsentApprovalRoutingModule } from './consent-approval-routing.module';
import { ConsentApprovalApiService } from './consent-approval-api.service';

@NgModule({
  imports: [
    ConsentApprovalRoutingModule,
  ],
  providers: [
    ConsentApprovalApiService,
  ],
})
export class ConsentApprovalModule {}
